module.exports = {
  "country": "UK",
  "artist": "Sonia",
  "song": "Better the Devil you know",
  "year": "1993",
  "place": "2",
  "spotify": "4z5d0yurzA3sM4wmwbEa5f"
};